import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStudioGames = async (orgId) =>
  (await axiosInstance.get(`v1/orgs/${orgId}/studio/games`))?.data

export default getStudioGames
